define('modules/editor/views/property_boxes/social_facebook',['require','exports','module','./base','ldsh!../../templates/property_boxes/social'],function(require, exports, module){
  "use strict";
  var BasePropertyBox = require("./base");
  module.exports = BasePropertyBox.extend({
    template: require("ldsh!../../templates/property_boxes/social")
  });
});

